import withActDetail from "../withActDetail";
import ActBacteriologicalTestForm from "./ActBacteriologicalTestForm";
import ActBacteriologicalPDFGenerator from "./ActBacteriologicalPDFGenerator";

const actFormKazakhName = 'Бактериологиялық тест алу АКТIСI'
const actFormName = 'АКТ отбора бактериологических тестов'
const actFormNumber = '001'
const actName = 'ActBacteriologicalTest'

export default withActDetail(ActBacteriologicalTestForm, ActBacteriologicalPDFGenerator, actFormKazakhName, actFormName, actFormNumber, actName)